import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getContinuousEducationSectionsAction } from '../actions';

const {
  useLoader: useContinuousEducationSectionsLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getContinuousEducationSectionsAction,
});

function ContinuousEducationSectionsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  ContinuousEducationSectionsLoader,
  useContinuousEducationSectionsLoader,
};
